import { render } from "./HospitalDetails.vue?vue&type=template&id=f2179770"
import script from "./HospitalDetails.vue?vue&type=script&lang=js"
export * from "./HospitalDetails.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/hospitals/HospitalDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f2179770"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f2179770', __exports__)) {
    console.log('reload')
    api.reload('f2179770', __exports__)
  }
  
  module.hot.accept("./HospitalDetails.vue?vue&type=template&id=f2179770", () => {
    console.log('re-render')
    api.rerender('f2179770', render)
  })

}


export default __exports__